import React from 'react';
import classnames from 'classnames';
import {DatePicker} from 'antd';
import dayjs from 'dayjs';
import 'dayjs/locale/he';
import locale from 'antd/es/date-picker/locale/he_IL';
import clearDatepicker from './assets/cross.svg';
import styles from './styles.module.scss';

const FilterDate = ({
                          filter: {
                            value,
                            onChange,
                            onReset,
                          },
                          containerStyles,
                          datepickerStyles,
                          maxDate,
                          placeholder,
                          dateFormat = 'DD-MM-YYYY',
                          clearable = true,
                          showToday = false,
                          disabled = false,
                          ...rest
                        }) => {
  return (
    <div
      className={classnames(styles.container, containerStyles)}
      onClick={(e) => e.stopPropagation()}
      onMouseDown={(e) => e.stopPropagation()}
      onKeyDown={(e) => e.stopPropagation()}
    >
      <DatePicker
        value={value && dayjs(value)}
        placeholder={placeholder}
        onChange={date => {
          if (onChange) {
            onChange(date.$d);
          }
        }}
        locale={locale}
        format={dateFormat}
        clearIcon={false}
        suffixIcon={false}
        className={classnames(
          styles.datepicker,
          {[styles.disabled]: disabled},
          styles['ant-picker-date-panel'],
          datepickerStyles
        )}
        disabled={disabled}
        showToday={showToday}
        maxDate={maxDate}
        {...rest}
      />
      {clearable && (
        <img
          src={clearDatepicker}
          alt="clear"
          className={styles.clearDateIcon}
          onClick={() => {
            if (onReset) {
              onReset();
            }
          }}
        />
      )}
    </div>
  );
};

export default FilterDate;
